import styled from "styled-components"
import {
  space,
  layout,
  color,
  flexbox,
  grid,
  background,
  border,
  shadow,
  position,
  typography,
} from "styled-system"

const Flex = styled.div.attrs(props => ({
  display: props.inline ? "inline-flex" : "flex",
  flex: props.flex ?? "1 1 auto",
  position: props.position ?? "relative",
  zIndex: props.zIndex ?? 0,
}))`
  ${space}
  ${layout}
  ${color}
  ${flexbox}
  ${grid}
  ${background}
  ${border}
  ${shadow}
  ${position}
  ${typography}

  ${props => (props.centered ? "justify-content: center;" : null)}
  ${props => (props.nogrow ? "flex-grow: 0;" : null)}
  ${props => (props.noshrink ? "flex-shrink: 0;" : null)}

  ${props =>
    props.enhanceClickableArea &&
    `
      &::after {
        content: "";
        position: absolute;
        left: -${props.enhanceClickableArea};
        right: -${props.enhanceClickableArea};
        top: -${props.enhanceClickableArea};
        bottom: -${props.enhanceClickableArea};
        ${
          process.env.APP_ENV === "development" &&
          `background: rgba(32, 32, 128, 0.25);`
        }
      }

      cursor: pointer;
    `}
`

Flex.displayName = "Flex"

export default Flex
